(function () {
  var section = document.querySelector('.online-logopedia__app-preview');
  if (section) {
    initAppPreview(section);
  }
  initSignupModal();
  initHeaderBrandScroll();
  initFloatingWidgetScroll();
})();

function initAppPreview(section) {

  var DEFAULT_SOLO_URL = 'https://r-hang-vadasz-889345739957.europe-west1.run.app/solo.html';

  function isMalformedSoloQueryKey(key) {
    var normalized = String(key || '').trim().toLowerCase();
    return normalized === 'mode=solo' || normalized === 'mode%3dsolo';
  }

  function soloPreviewUrl(raw) {
    var url = (raw || '').trim();
    if (!url) return DEFAULT_SOLO_URL;
    try {
      var parsed = new URL(url, window.location.href);
      Array.from(parsed.searchParams.keys()).forEach(function (key) {
        if (isMalformedSoloQueryKey(key)) parsed.searchParams.delete(key);
      });
      parsed.searchParams.set('mode', 'solo');
      parsed.searchParams.set('embed', '1');
      if (parsed.hash === '#solo') parsed.hash = '';
      return parsed.origin + '/solo.html' + (parsed.search || '?task=1');
    } catch (_err) {
      return DEFAULT_SOLO_URL;
    }
  }

  var meta = document.querySelector('meta[name="logopediapp-preview-url"]');
  var explicitOverride =
    typeof window.LOGOPEDIAPP_PREVIEW_URL === 'string' && window.LOGOPEDIAPP_PREVIEW_URL.trim();
  var configured = soloPreviewUrl(
    explicitOverride ||
      (section.getAttribute('data-app-url') || '').trim() ||
      (meta && meta.getAttribute('content')) ||
      DEFAULT_SOLO_URL
  );

  var host = window.location.hostname;
  if (!explicitOverride && (host === 'localhost' || host === '127.0.0.1')) {
    configured = soloPreviewUrl(window.location.origin + '/');
  }

  var shell = section.querySelector('.online-logopedia__app-preview-shell');
  var frame = section.querySelector('.online-logopedia__app-preview-frame');
  var iframe = section.querySelector('.online-logopedia__app-preview-iframe');
  if (iframe) iframe.src = configured;

  section.querySelectorAll('[data-app-link]').forEach(function (link) {
    link.setAttribute('href', configured);
  });

  function isCoarsePointerDevice() {
    return (
      window.matchMedia('(pointer: coarse)').matches
      || window.matchMedia('(hover: none)').matches
    );
  }

  function activatePreview() {
    if (!shell) return;
    shell.classList.add('is-active');
    if (iframe) {
      iframe.removeAttribute('tabindex');
      iframe.style.pointerEvents = 'auto';
    }
  }

  if (shell && frame && iframe) {
    var coarse = isCoarsePointerDevice();
    if (coarse) {
      shell.classList.add('is-coarse');
      iframe.style.pointerEvents = 'none';

      var overlay = document.createElement('button');
      overlay.type = 'button';
      overlay.className = 'online-logopedia__app-preview-overlay';
      overlay.setAttribute('aria-label', 'Érintsd meg a LogopédiApp kipróbálásához');
      overlay.innerHTML =
        '<span class="online-logopedia__app-preview-overlay__hint">'
        + '<span class="online-logopedia__app-preview-overlay__icon" aria-hidden="true">'
        + '<svg viewBox="0 0 24 24" width="26" height="26" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round">'
        + '<path d="M12 2a10 10 0 0 1 10 10c0 5.52-4.48 10-10 10S2 17.52 2 12 6.48 2 12 2z"/>'
        + '<path d="M8 14s1.5 2 4 2 4-2 4-2"/>'
        + '<line x1="9" y1="9" x2="9.01" y2="9"/><line x1="15" y1="9" x2="15.01" y2="9"/>'
        + '</svg></span>'
        + '<span>Érintsd meg a kipróbáláshoz</span>'
        + '</span>';
      frame.appendChild(overlay);

      overlay.addEventListener('click', activatePreview);
      overlay.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          activatePreview();
        }
      });
    }
  }
}

function initHeaderBrandScroll() {
  var headerBrand = document.querySelector('.online-header .brand--mini-logo');
  if (!headerBrand) return;
  headerBrand.addEventListener('click', function (event) {
    event.preventDefault();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
}

function initFloatingWidgetScroll() {
  var body = document.body;
  if (!body.classList.contains('online-page')) return;

  var lastY = window.scrollY || 0;
  var idleTimer = null;
  var IDLE_MS = 650;
  var MIN_DELTA = 6;

  function setWidgetsVisible(visible) {
    body.classList.toggle('ol-floating-widgets--visible', visible);
    body.classList.toggle('ol-floating-widgets--hidden', !visible);
  }

  function hideAfterIdle() {
    clearTimeout(idleTimer);
    idleTimer = setTimeout(function () {
      setWidgetsVisible(false);
    }, IDLE_MS);
  }

  function onScroll() {
    if (body.classList.contains('ol-signup-modal-open')) {
      setWidgetsVisible(false);
      return;
    }

    var y = window.scrollY || 0;
    var delta = y - lastY;

    if (Math.abs(delta) >= MIN_DELTA) {
      if (delta < 0) {
        setWidgetsVisible(true);
      } else {
        setWidgetsVisible(false);
      }
      lastY = y;
    }

    hideAfterIdle();
  }

  setWidgetsVisible(false);
  window.addEventListener('scroll', onScroll, { passive: true });
  hideAfterIdle();
}

function initSignupModal() {
  var modal = document.getElementById('ol-signup-modal');
  var form = document.getElementById('ol-signup-form');
  if (!modal || !form) return;

  var DEFAULT_API =
    'https://r-hang-vadasz-889345739957.europe-west1.run.app/api/leads';
  var DEFAULT_THANK_YOU = 'https://mosolykulcs.hu/pages/jelentkezes-koszonjuk';

  var apiMeta = document.querySelector('meta[name="online-logopedia-leads-api"]');
  var fallbackMeta = document.querySelector('meta[name="online-logopedia-leads-fallback"]');
  var thankYouMeta = document.querySelector('meta[name="online-logopedia-thank-you-url"]');
  var leadsApi = ((apiMeta && apiMeta.getAttribute('content')) || DEFAULT_API).trim();
  var thankYouUrl = ((thankYouMeta && thankYouMeta.getAttribute('content')) || DEFAULT_THANK_YOU).trim();
  var leadsFallback = ((fallbackMeta && fallbackMeta.getAttribute('content')) || 'shopify-contact').trim().toLowerCase();

  var errorEl = document.getElementById('ol-signup-error');
  var submitBtn = form.querySelector('[type="submit"]');
  var lastFocused = null;


  function isCrossOriginLeadsApi(apiUrl) {
    try {
      return new URL(apiUrl, window.location.href).origin !== window.location.origin;
    } catch (e) {
      return true;
    }
  }

  function shouldUseShopifyContactFallback(err) {
    if (!err) return false;
    if (err.name === 'TypeError') return true;
    var msg = String(err.message || err);
    return /failed to fetch|networkerror|load failed/i.test(msg);
  }

  function buildLeadPayload(name, email, phone, childName, childBirthDate, helpNeeded) {
    return {
      name: name,
      email: email,
      phone: phone,
      childName: childName,
      childBirthDate: childBirthDate,
      helpNeeded: helpNeeded,
      source: 'landing-signup',
    };
  }

  function buildShopifyContactMessage(payload) {
    return [
      'Online Logopédia jelentkezés (modal)',
      'Név: ' + payload.name,
      'Telefon: ' + payload.phone,
      'Gyermek neve: ' + payload.childName,
      'Gyermek születési ideje: ' + payload.childBirthDate,
      'Segítség: ' + payload.helpNeeded,
      'Forrás: ' + payload.source,
    ].join('\n');
  }

  function isShopifyContactSuccessResponse(response, body) {
    if (!response) return false;
    if (response.ok) return true;
    if (response.status >= 300 && response.status < 400) return true;
    if (response.status === 0) return true;
    if (!body) return false;
    var trimmed = String(body).trim();
    if (/^\s*\{/.test(trimmed)) {
      try {
        var data = JSON.parse(trimmed);
        if (data && (data.posted === true || data.ok === true)) return true;
      } catch (_err) {}
    }
    return /thank\s*you|köszön|sikeresen|contact.*posted|form.*posted/i.test(trimmed);
  }

  function getShopifyContactForm() {
    if (form.getAttribute('action') === '/contact') return form;
    return (
      document.getElementById('ol-shopify-contact-bridge')
      || document.querySelector('form[data-shopify-captcha="true"][action="/contact"]')
      || document.querySelector('form.contact-form[action="/contact"], form[action="/contact"]')
    );
  }

  function readFormValue(contactSelector, legacyName, dataField) {
    var contactInput = form.querySelector(contactSelector);
    if (contactInput) return String(contactInput.value || '').trim();
    if (dataField) {
      var dataInput = form.querySelector('[data-ol-field="' + dataField + '"]');
      if (dataInput) return String(dataInput.value || '').trim();
    }
    if (legacyName && form[legacyName]) return String(form[legacyName].value || '').trim();
    return '';
  }

  function populateShopifyContactForm(payload) {
    var contactForm = getShopifyContactForm();
    if (!contactForm) return false;
    var bodyInput = contactForm.querySelector('[name="contact[body]"]');
    if (!bodyInput) return false;
    bodyInput.value = buildShopifyContactMessage(payload);
    return true;
  }

  function submitNativeShopifyContactForm(contactForm) {
    function doNativeSubmit() {
      contactForm.dataset.olNativeSubmit = '1';
      if (typeof contactForm.requestSubmit === 'function') {
        contactForm.requestSubmit();
        return;
      }
      contactForm.submit();
    }

    if (window.Shopify && Shopify.captcha && typeof Shopify.captcha.protect === 'function') {
      Shopify.captcha.protect(contactForm, doNativeSubmit);
      return;
    }
    doNativeSubmit();
  }

  function submitViaShopifyContact(payload) {
    var contactForm = getShopifyContactForm();
    if (!contactForm || !populateShopifyContactForm(payload)) {
      return Promise.reject(new Error('Nem sikerült elküldeni a jelentkezést.'));
    }
    submitNativeShopifyContactForm(contactForm);
    return Promise.resolve({ response: { ok: true }, data: { ok: true } });
  }

  function postLeadToApi(payload) {
    return fetch(leadsApi, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    }).then(function (response) {
      return response.json().catch(function () {
        return { ok: false, error: 'Váratlan válasz a szervertől.' };
      }).then(function (data) {
        return { response: response, data: data };
      });
    });
  }

  function shouldRetryViaShopifyContact(result) {
    if (leadsFallback === 'none' || !isCrossOriginLeadsApi(leadsApi)) return false;
    if (!result || !result.response) return true;
    if (result.response.ok && result.data && result.data.ok) return false;
    return true;
  }

  function submitLead(payload) {
    if (leadsFallback === 'shopify-only' && isCrossOriginLeadsApi(leadsApi)) {
      return submitViaShopifyContact(payload);
    }
    return postLeadToApi(payload)
      .then(function (result) {
        if (shouldRetryViaShopifyContact(result)) {
          return submitViaShopifyContact(payload);
        }
        return result;
      })
      .catch(function (err) {
        if (
          leadsFallback !== 'none'
          && isCrossOriginLeadsApi(leadsApi)
          && shouldUseShopifyContactFallback(err)
        ) {
          return submitViaShopifyContact(payload);
        }
        throw err;
      });
  }

  function setError(message) {
    if (!errorEl) return;
    if (message) {
      errorEl.textContent = message;
      errorEl.hidden = false;
    } else {
      errorEl.textContent = '';
      errorEl.hidden = true;
    }
  }

  function prepareShopifyCaptcha() {
    var contactForm = getShopifyContactForm();
    if (!contactForm || contactForm.dataset.captchaPrepared === 'true') return;
    if (window.Shopify && Shopify.captcha && typeof Shopify.captcha.protect === 'function') {
      Shopify.captcha.protect(contactForm, function () {
        contactForm.dataset.captchaPrepared = 'true';
      });
    }
  }

  function openModal() {
    lastFocused = document.activeElement;
    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('ol-signup-modal-open');
    prepareShopifyCaptcha();
    var firstInput =
      form.querySelector('[name="contact[name]"]')
      || form.querySelector('input[name="name"]');
    if (firstInput) firstInput.focus();
  }

  function closeModal() {
    modal.hidden = true;
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('ol-signup-modal-open');
    setError('');
    if (lastFocused && typeof lastFocused.focus === 'function') {
      lastFocused.focus();
    }
  }

  document.querySelectorAll('[data-signup-trigger]').forEach(function (trigger) {
    trigger.addEventListener('click', function (event) {
      event.preventDefault();
      openModal();
    });
  });

  modal.querySelectorAll('[data-signup-close]').forEach(function (el) {
    el.addEventListener('click', closeModal);
  });

  document.addEventListener('keydown', function (event) {
    if (modal.hidden) return;
    if (event.key === 'Escape') closeModal();
  });

  form.addEventListener('submit', function (event) {
    if (form.dataset.olNativeSubmit === '1') {
      form.dataset.olNativeSubmit = '';
      return;
    }

    event.preventDefault();
    setError('');

    var name = readFormValue('[name="contact[name]"]', 'name');
    var email = readFormValue('[name="contact[email]"]', 'email');
    var phone = readFormValue('[name="contact[phone]"]', 'phone');
    var childName = readFormValue(null, 'childName', 'childName');
    var childBirthDate = readFormValue(null, 'childBirthDate', 'childBirthDate');
    var helpNeeded = readFormValue(null, 'helpNeeded', 'helpNeeded');

    if (name.length < 2) {
      setError('Add meg a neved (legalább 2 karakter).');
      (form.querySelector('[name="contact[name]"]') || form.name).focus();
      return;
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setError('Adj meg érvényes e-mail címet.');
      (form.querySelector('[name="contact[email]"]') || form.email).focus();
      return;
    }
    if (phone.replace(/\D/g, '').length < 8) {
      setError('Adj meg érvényes telefonszámot.');
      (form.querySelector('[name="contact[phone]"]') || form.phone).focus();
      return;
    }
    if (childName.length < 2) {
      setError('Add meg a gyermek nevét (legalább 2 karakter).');
      (form.querySelector('[data-ol-field="childName"]') || form.childName).focus();
      return;
    }
    if (!/^\d{4}-\d{2}-\d{2}$/.test(childBirthDate)) {
      setError('Add meg a gyermek születési idejét.');
      (form.querySelector('[data-ol-field="childBirthDate"]') || form.childBirthDate).focus();
      return;
    }
    if (helpNeeded.length < 5) {
      setError('Írd le néhány szóban, miben vár segítséget (legalább 5 karakter).');
      (form.querySelector('[data-ol-field="helpNeeded"]') || form.helpNeeded).focus();
      return;
    }

    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.setAttribute('aria-busy', 'true');
    }

    var leadPayload = buildLeadPayload(
      name,
      email,
      phone,
      childName,
      childBirthDate,
      helpNeeded
    );

    if (leadsFallback === 'shopify-only' && isCrossOriginLeadsApi(leadsApi)) {
      if (!populateShopifyContactForm(leadPayload)) {
        setError('Nem sikerült elküldeni a jelentkezést.');
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.removeAttribute('aria-busy');
        }
        return;
      }
      submitNativeShopifyContactForm(form);
      return;
    }

    submitLead(leadPayload)
      .then(function (result) {
        if (result.data && result.data.ok) {
          window.location.href = thankYouUrl;
          return;
        }
        if (isShopifyContactSuccessResponse(result.response, '')) {
          window.location.href = thankYouUrl;
          return;
        }
        throw new Error(
          (result.data && result.data.error) || 'Nem sikerült elküldeni a jelentkezést.'
        );
      })
      .catch(function (err) {
        setError(err.message || 'Hiba történt. Próbáld újra, vagy használd a Google űrlapot.');
      })
      .finally(function () {
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.removeAttribute('aria-busy');
        }
      });
  });
}
